import { takeLatest, select, put } from 'redux-saga/effects';

import { targetUserIdSelector } from '../../context/selectors';

import { consts as deleteCardConsts } from '../requests/delete-card-req';
import { actions as paymentsActions } from '../requests/payments-req';

export function* handleRefetchPaymentMethods() {
  const userId = yield select(targetUserIdSelector);

  yield put(paymentsActions.send({ userId }));
}

export function* refetchPaymentMethods() {
  yield takeLatest([deleteCardConsts.SUCCEED], handleRefetchPaymentMethods);
}



// WEBPACK FOOTER //
// ./src/redux/payment-methods/sagas/refetch-payment-methods.js